/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_SelectInputs */

const en_general_select = /** @type {(inputs: General_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select`)
};

const de_general_select = /** @type {(inputs: General_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswählen`)
};

/**
* | output |
* | --- |
* | "Select" |
*
* @param {General_SelectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_select = /** @type {((inputs?: General_SelectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_SelectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_select(inputs)
	return de_general_select(inputs)
});